import { z } from 'zod';
import { optionalEditFormTrimmedString } from '../zod-helpers/index.js';
export const userEditFormSchema = z.object({
    phone: optionalEditFormTrimmedString(255),
});
//# sourceMappingURL=edit-form.js.map